module.exports = __webpack_public_path__ + "img/horizontal_2_1_9006.f2f69ba3.png";